export interface AppVersionInfo {
  buildId: string;
  builtAt?: string;
}

/** Build-ID der aktuell laufenden SPA-Instanz (eingebettet beim Build). */
export function getLocalBuildId(): string {
  if (import.meta.env.DEV) return "dev";
  try {
    return typeof __APP_BUILD_ID__ === "string" ? __APP_BUILD_ID__ : "unknown";
  } catch {
    return "unknown";
  }
}

/** Lädt die auf dem Server ausliegende Version (version.json, ohne Cache). */
export async function fetchRemoteAppVersion(): Promise<AppVersionInfo | null> {
  try {
    const res = await fetch(`/version.json?_=${Date.now()}`, {
      cache: "no-store",
      credentials: "same-origin",
    });
    if (!res.ok) return null;
    const data = (await res.json()) as Partial<AppVersionInfo>;
    const buildId = (data.buildId || "").trim();
    if (!buildId) return null;
    return {
      buildId,
      builtAt: data.builtAt,
    };
  } catch {
    return null;
  }
}

export function isNewerRemoteBuild(
  localBuildId: string,
  remoteBuildId: string,
): boolean {
  if (!localBuildId || !remoteBuildId) return false;
  if (localBuildId === "dev" || localBuildId === "unknown") return false;
  return localBuildId !== remoteBuildId;
}
